<script>
    export let page_title;

    import {pop,replace} from 'svelte-spa-router'
    export let is_section_main_page = false;
    
    //back link on section main/first page goes always to app front page
    function handle_back_press(){
        if(!is_section_main_page){
            pop();
        }else{
            replace("/");
        }
    }
</script>
<header class="sub-page">
    <button id="back-link" on:click={() => handle_back_press()}>
        <img src="img/icons/arrow-left-solid-white.svg" alt="Back" />
    </button>
    <span class="page-title">
        {page_title}
    </span>
</header>
<style>
    .page-title{
        font-family: 'futura-pt', Arial;
        color: #fff;
        font-weight: 700;
        text-decoration: none;
        text-transform: uppercase;
        font-size: 1.4rem;
    }
    header{
        z-index: 2;
    }

    #back-link{
        position: absolute;
        left: 15px;
        background: none;
        border: none;
        color: #fff;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    #back-link img{
        width: 20px;
        height: auto;
    }
</style>